import { render, staticRenderFns } from "./bookResource.vue?vue&type=template&id=996c208c&scoped=true&"
import script from "./bookResource.vue?vue&type=script&lang=js&"
export * from "./bookResource.vue?vue&type=script&lang=js&"
import style0 from "./bookResource.vue?vue&type=style&index=0&id=996c208c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996c208c",
  null
  
)

export default component.exports